import React from "react";
import {
  Folder,
  File,
  FileText,
  Image,
  Video,
  Music,
  Archive,
  Code,
  Sheet,
  Presentation,
  Calendar,
  Mail,
  Map,
  Database,
} from "lucide-react";

export function getFileIcon(mimeType: string, isFolder: boolean): React.ReactNode {
  if (isFolder) return <Folder className="h-3 w-3 sm:h-4 sm:w-4 text-blue-500" />;

  if (mimeType.startsWith("image/"))
    return <Image className="h-3 w-3 sm:h-4 sm:w-4 text-green-500" />;
  if (mimeType.startsWith("video/"))
    return <Video className="h-3 w-3 sm:h-4 sm:w-4 text-purple-500" />;
  if (mimeType.startsWith("audio/"))
    return <Music className="h-3 w-3 sm:h-4 sm:w-4 text-pink-500" />;
  if (mimeType.includes("pdf")) return <FileText className="h-3 w-3 sm:h-4 sm:w-4 text-red-500" />;
  if (mimeType.includes("document"))
    return <FileText className="h-3 w-3 sm:h-4 sm:w-4 text-blue-600" />;
  if (mimeType.includes("spreadsheet"))
    return <Sheet className="h-3 w-3 sm:h-4 sm:w-4 text-green-600" />;
  if (mimeType.includes("presentation"))
    return <Presentation className="h-3 w-3 sm:h-4 sm:w-4 text-orange-500" />;
  if (mimeType.includes("calendar"))
    return <Calendar className="h-3 w-3 sm:h-4 sm:w-4 text-indigo-500" />;
  if (mimeType.includes("mail")) return <Mail className="h-3 w-3 sm:h-4 sm:w-4 text-blue-500" />;
  if (mimeType.includes("maps")) return <Map className="h-3 w-3 sm:h-4 sm:w-4 text-green-500" />;
  if (mimeType.includes("database") || mimeType.includes("sql"))
    return <Database className="h-3 w-3 sm:h-4 sm:w-4 text-gray-600 dark:text-gray-400" />;
  if (mimeType.includes("zip") || mimeType.includes("archive"))
    return <Archive className="h-3 w-3 sm:h-4 sm:w-4 text-yellow-600" />;
  if (
    mimeType.includes("javascript") ||
    mimeType.includes("json") ||
    mimeType.includes("html") ||
    mimeType.includes("css")
  )
    return <Code className="h-3 w-3 sm:h-4 sm:w-4 text-indigo-600" />;

  return <File className="h-3 w-3 sm:h-4 sm:w-4 text-gray-500" />;
}
